// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eeTW","buttons":"styles_buttons__vwIyp"};